import React, { useState } from "react";
import { MessageSquare, X, Send } from "lucide-react";
import api from "../lib/api";
import { motion, AnimatePresence } from "framer-motion";

export default function ChatWidget() {
  const [open, setOpen] = useState(false);
  const [msgs, setMsgs] = useState([
    { role: "assistant", text: "Hi — I'm Sella, your SellePack assistant. Ask me about shipments, wallets, surcharges, or tracking." },
  ]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);

  const send = async () => {
    if (!input.trim() || loading) return;
    const text = input.trim();
    setMsgs((m) => [...m, { role: "user", text }]);
    setInput("");
    setLoading(true);
    try {
      const { data } = await api.post("/ai/chat", { message: text });
      setMsgs((m) => [...m, { role: "assistant", text: data.reply }]);
    } catch (e) {
      setMsgs((m) => [...m, { role: "assistant", text: "Sorry, I hit an error. Try again." }]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <button
        data-testid="chat-widget-toggle"
        onClick={() => setOpen((o) => !o)}
        className="fixed bottom-6 right-6 z-50 brand-bg text-white w-14 h-14 rounded-full shadow-lg hover:shadow-xl flex items-center justify-center transition-all"
      >
        {open ? <X size={22} /> : <MessageSquare size={22} />}
      </button>
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: 20, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 20, scale: 0.95 }}
            transition={{ duration: 0.18 }}
            className="fixed bottom-24 right-6 z-50 w-[380px] max-w-[calc(100vw-2rem)] h-[520px] bg-white border border-zinc-200 rounded-md shadow-2xl flex flex-col"
            data-testid="chat-widget-panel"
          >
            <div className="px-4 py-3 border-b border-zinc-200 flex items-center justify-between">
              <div>
                <div className="font-display font-bold text-zinc-900">Sella · AI Support</div>
                <div className="text-xs text-zinc-500">Powered by Claude Sonnet 4.5</div>
              </div>
              <span className="text-xs px-2 py-0.5 bg-emerald-50 text-emerald-700 rounded-sm uppercase tracking-wider font-medium">Online</span>
            </div>
            <div className="flex-1 overflow-y-auto p-3 space-y-3">
              {msgs.map((m, i) => (
                <div key={i} className={`flex ${m.role === "user" ? "justify-end" : "justify-start"}`}>
                  <div className={`max-w-[85%] px-3 py-2 text-sm rounded-md ${m.role === "user" ? "brand-bg text-white" : "bg-zinc-100 text-zinc-900"}`}>
                    {m.text}
                  </div>
                </div>
              ))}
              {loading && <div className="text-xs text-zinc-500 font-mono-plex">Sella is typing…</div>}
            </div>
            <div className="p-3 border-t border-zinc-200 flex gap-2">
              <input
                data-testid="chat-input"
                value={input}
                onChange={(e) => setInput(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && send()}
                placeholder="Ask about a shipment…"
                className="flex-1 border border-zinc-300 rounded-sm px-3 py-2 text-sm focus:outline-none focus:border-[var(--brand-accent)]"
              />
              <button data-testid="chat-send" onClick={send} className="brand-bg text-white px-3 rounded-sm hover:opacity-90">
                <Send size={16} />
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}
